import WxmSessionExpired from './src/main.vue';

WxmSessionExpired.install = function (Vue) {
    Vue.component(WxmSessionExpired.name, WxmSessionExpired)
};
if (typeof window !== 'undefined' && window.Vue) {
    WxmSessionExpired.install(window.Vue);
}

export default WxmSessionExpired;
